import { sortObjects } from './arrays';

export function countAnswers(obj) {
  try {
    let allLetters = [...new Set(Object.values(obj).map((letter) => letter.letter))];
    let answersGathered = {};
    allLetters.forEach((letter) => {
      answersGathered[letter] = 0;
    });
    Object.values(obj).forEach((answer) => {
      answersGathered[answer.letter] = answersGathered[answer.letter] + answer.grade;
    });

    answersGathered = Object.entries(answersGathered);

    answersGathered = answersGathered.map((ans) => {
      return { letter: ans[0], grade: ans[1] };
    });
    return sortObjects(answersGathered, 'grade', 'desc');
  } catch (error) {
    return [{}];
  }
}

export const singleSelectionOptions = [
  '1. Totalmente en desacuerdo',
  '2. En desacuerdo',
  '3. Ni de acuerdo ni en desacuerdo',
  '4. De acuerdo',
  '5. Totalmente de acuerdo',
];
